import { render } from "./AssignmentFFVVToEnrollmentsView.vue?vue&type=template&id=21c1321f&scoped=true"
import script from "./AssignmentFFVVToEnrollmentsView.vue?vue&type=script&lang=js"
export * from "./AssignmentFFVVToEnrollmentsView.vue?vue&type=script&lang=js"

import "./AssignmentFFVVToEnrollmentsView.vue?vue&type=style&index=0&id=21c1321f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c1321f"]])

export default __exports__